import type { IconProps } from 'vuetify'
import VBtnExtended from '../vuetify/VBtnExtended'

export default defineNuxtPlugin((nuxtApp) => {
  // NOTE: The icons need to be configure here inside a plugin for some reason.
  // See https://vuetify-nuxt-module.netlify.app/guide/icons/integrations.html#integrations
  nuxtApp.hook('vuetify:before-create', (vuetify) => {
    vuetify.vuetifyOptions.icons = {
      defaultSet: 'custom',
      aliases: {
        checkboxOn: 'icon-checkbox-check',
        checkboxOff: 'icon-checkmark',
        radioOn: 'icon-radio-active',
        radioOff: 'icon-radio-active',
        next: 'icon-arrow-right',
        prev: 'icon-arrow-left',
        sortDesc: 'icon-arrow-up',
        sortAsc: 'icon-arrow-down',
        dropdown: 'icon-arrow-down',
        sort: 'icon-arrow-down',
        subgroup: 'icon-arrow-down',
      },
      sets: {
        custom: {
          component: (props: IconProps) => h('i', { class: `${props.icon}` }),
        },
      },
    }

    vuetify.vuetifyOptions.aliases = {
      ...vuetify.vuetifyOptions.aliases,
      VBtn: VBtnExtended,
      VBtnPrimary: VBtnExtended,
      VBtnSecondary: VBtnExtended,
      VBtnDefault: VBtnExtended,
      VBtnCritical: VBtnExtended,
      VBtnGhost: VBtnExtended,
      VBtnHeaderIcons: VBtnExtended,
    }
  })
})
